import { render, staticRenderFns } from "./WelcomingMobile.vue?vue&type=template&id=c8d69e82&scoped=true"
import script from "./WelcomingMobile.vue?vue&type=script&lang=js"
export * from "./WelcomingMobile.vue?vue&type=script&lang=js"
import style0 from "./WelcomingMobile.vue?vue&type=style&index=0&id=c8d69e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d69e82",
  null
  
)

export default component.exports